export const HOME_PAGE_ROUTE = '/';
export const BUSINESS_LOAN_PAGE_ROUTE = '/business-loans';
export const PERSONAL_LOAN_PAGE_ROUTE = '/personal-loans';
export const ABOUT_US_PAGE_ROUTE = '/about-us';
export const CONTACT_US_PAGE_ROUTE = '/contact-us';
export const PRIVACY_POLICY_PAGE_ROUTE = '/privacy-policy';
export const TERMS_N_COND_PAGE_ROUTE = '/terms-of-use';
export const DISCLAIMER_PAGE_ROUTE = '/disclaimer';
export const THANK_YOU_PAGE_ROUTE = '/thank-you';
export const INTELLECTUAL_PROPERTY_PAGE_ROUTE = '/intellectual-property';
export const GRIEVANCE_REDRESSAL_PAGE_ROUTE = '/grievance-redressal';
export const GRIEVANCE_REDRESSAL_BUSINESS_PAGE_ROUTE =
  '/grievance-redressal/business';
export const GRIEVANCE_REDRESSAL_PERSONAL_PAGE_ROUTE =
  '/grievance-redressal/personal';
export const CREDIT_TERMS_N_COND_PAGE_ROUTE = '/credit-terms-of-use';
export const EXPERIAN_TERMS_N_COND_PAGE_ROUTE = '/experian-terms-of-use';

// Credit related routes
export const CREDIT_REPORT_APPLY_ROUTE = '/credit-report/apply';
export const BL_USER_DETAILS_ROUTE = '/credit-report/apply/bl/user-details';
export const BL_PAN_ROUTE = '/credit-report/apply/bl/pan';
export const BL_MASKED_ROUTE = '/credit-report/apply/bl/masked';
export const BL_STEPS_ROUTE = '/credit-report/apply/bl/steps';
export const BL_BUSINESS_DETAILS_ROUTE =
  '/credit-report/apply/bl/business-details';
export const BL_BANK_STATEMENT_ROUTE = '/credit-report/apply/bl/bank-statement';
export const BL_LENDERS_ROUTE = '/credit-report/apply/bl/lenders-details';
export const BL_UPLOAD_DOCS_ROUTE = '/credit-report/apply/bl/upload-docs';
export const BL_OFFERS_ROUTE = '/credit-report/apply/bl/offers';
export const GST_ROUTE = '/credit-report/apply/bl/gst';
export const CREDIT_REPORT = '/credit-report';
export const CREDIT_FAQS = '/credit-report/faqs';
export const CREDIT_PROFILE = '/credit-report/profile';
export const CREDIT_CONTACT_US = '/credit-report/contact-us';
